import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Step } from '../../stepper/step';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'stepper-new-inner',
	template: require('./stepper-new-inner.component.html'),
})
export class StepperNewInnerComponent {
	@Input()
	transactionSteps: Step[];

	@Output()
	emitStep: EventEmitter<number> = new EventEmitter<number>();

	isExpanded: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	emitSteps(i: number) {
		this.emitStep.emit(i);
	}

	constructor() {}

	findStep(): number {
		let i = 0;
		while (i < this.transactionSteps.length) {
			if (this.transactionSteps[i].isActive) {
				i++;
			} else {
				return i;
			}
		}
		return i;
	}

	expander(): void {
		this.isExpanded = !this.isExpanded;
	}
	isCurrentStep(index: number) {
		if (this.transactionSteps[index].isActive) {
			return true;
		}
		return (
			(index + 1 === this.transactionSteps.length ||
				!this.transactionSteps[index + 1].isActive) &&
			this.transactionSteps[index].isActive
		);
	}
	findActive(i: number) {
		if (i !== this.transactionSteps.length - 1) {
			return this.transactionSteps[i + 1].isActive;
		} else {
			return false;
		}
	}
}
